import React from "react";
import { useScrollReveal } from "./useAnimations";
import "./CTAFooter.scss";

const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const CTAFooter = () => {
  const [ref, vis] = useScrollReveal({ threshold: 0.15 });

  return (
    <section className="ctaf" ref={ref}>
      <div className="ctaf__inner">
        <h2 className={`ctaf__title${vis ? " is-visible" : ""}`}>
          Move from Uncertainty{" "}
          <em className="ctaf__title-italic">to Execution</em>
        </h2>
        <p className={`ctaf__desc${vis ? " is-visible" : ""}`}>
          Book a senior-led strategy discussion and we will assess your current
          position, identify the highest-priority risks and opportunities, and
          recommend the clearest next step for your organisation.
        </p>
        <div className={`ctaf__actions${vis ? " is-visible" : ""}`}>
          <a href="/contact-us" className="ctaf__btn-primary">
            Schedule a Strategy Call <ArrowIcon />
          </a>
          <a href="/contact-us" className="ctaf__btn-outline">
            Explore All Engagements <ArrowIcon />
          </a>
        </div>
        <p className={`ctaf__note${vis ? " is-visible" : ""}`}>
          Senior-led &nbsp;&middot;&nbsp; Fixed scope &nbsp;&middot;&nbsp; No
          obligation &nbsp;&middot;&nbsp; A clear next step in 30 minutes
        </p>
      </div>
    </section>
  );
};

export default CTAFooter;
